<script lang="ts" setup>
	const { productCategoryType } = useUtils()
	const { getProductsByCategory } = useProductLogic('business')
	const { attachExternalLink } = useProductsStore()
	const categoryType = (e: string, code_name?: number) => productCategoryType(e, String(code_name))
	const filteredList = computed(() => {
		return getProductsByCategory.value['gadget']
	})
</script>
<template>
	<div>
		<div class="max-w-[798px] mx-auto pb-12">
			<ui-title-header
				title="Work never has to stop"
				:ui="{
					size: 'text-[2rem]/[2.4rem] md:text-[2.625rem]/[3.15rem] lg:text-[3.25rem]/[3.9rem]',
					lineHeight: ''
				}"
				class="text-center max-w-[355px] md:max-w-[952px] mx-auto"
			/>
		</div>

		<div class="bg-gadget-500 w-full sm:p-10 py-10">
			<ui-pad>
				<ui-carousel v-if="Array.isArray(filteredList)" :ui="{ wrapper: { default: 'xl:justify-center' } }">
					<ui-pricing-card
						v-for="(item, index) in filteredList"
						:key="index"
						:benefit_highlight="item?.pricingBenefits?.dedicated_benfit"
						:name="{
							text: item.name
						}"
						:description="{
							text: ''
						}"
						:individual-tag="item.pricingBenefits?.individualTag ?? ''"
						:ui="{
							wrapper: {
								height: '',
								hover: '',
								padding: 'px-5 pb-5 pt-5 sm:py-0',
								bg: 'bg-[#FBF3FA]',
								base: `self-stretch flex flex-col snap-center`,
								width: 'max-w-[320px] md:max-w-[440px]'
							},
							actionBtn: {
								base: 'w-full h-[56px] border active:scale-105 rounded-[40px]',
								display: '',
								padding: '',
								text: ''
							},
							heading: {
								border: '',
								spacer: 'space-y-1.5',
								name: {
									base: 'inline-block text-gadget-500 mb-3  ',
									hover: '',
									text: 'text-gadget-500',
									size: 'sm:text-xl text-base'
								}
							},
							list: {
								text: 'text-gray-500 font-medium',
								default: 'sm:pb-20',
								iconBase: 'fill-gadget-500',
								iconHover: '',
								size: 'text-base'
							}
						}"
						class="flex-none lg:mx-0 mx-auto"
						no-icon
					>
						<template #description>
							<p class="text-gray-500 text-sm text-pretty inline-flex flex-wrap items-end gap-1 lg:pt-4">
								<span class="font-bold md:text-[2em] text-3xl text-nowrap text-blue-950">
									<span class="md:text-[2.5em] text-3xl"
										>{{ parseFloat(String(item.market_price)) }}%</span
									>
									of
									{{
										categoryType(item?.productCategory?.name ?? '', item?.code_name ?? 0)?.isLaptop
											? 'laptop'
											: 'gadget'
									}}
									value
								</span>
								{{
									categoryType(item?.productCategory?.name ?? '', item?.code_name ?? 0)?.isGadget &&
									!categoryType(item?.productCategory?.name ?? '', item?.code_name ?? 0)?.isLaptop
										? '/ gadget annually'
										: '/laptop annually'
								}}
							</p>
						</template>
						<template #btn-group>
							<div class="space-y-3 mt-auto border-t pt-5 relative z-10 pb-5">
								<nuxt-link
									:to="attachExternalLink('business', `/register/${item.id}`)"
									external
									target="_blank"
									rel="noopener noreferrer"
									class="relative z-10 transition hover:bg-gadget-600 sm:text-base bg-gadget-500 text-white default-btn w-full justify-center md:py-[14px]"
									name="self onboard"
								>
									<span>Get covered</span>
								</nuxt-link>
							</div>
						</template>
					</ui-pricing-card>
				</ui-carousel>
			</ui-pad>
		</div>
	</div>
</template>

<style></style>
